<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapnum"><a id="page_ii"><em class="italic">Introduction</em></a></h2><a id="page_ii">
<p class="noindent">The opening paragraph of this space opera has frequently been quoted, if only by me:</p>
<div class="quote">
<p class="noindent">Four things one particularly notices after wars of any respectable size: preparations for the next one, confidence that armed conflict is finished for ever, starvation, and feasting.</p>
</div>
<p class="indent">The text is operatic; I was attempting to write a space opera.</p>
<p class="indent">My original American publisher, Doubleday, explained everything clearly on their dust jacket, and I loved them for it: ‘Seldom has a novel been more crammed with crazy but plausible ideas, awful jokes, and nutty people. Oh, we forgot to mention the latest technological advance, the ecopicosystem. And total contraception. And all the singing and dancing. And the massive drinking scene. And the updated Adam and Eve bit … <em class="italic">The Eighty Minute Hour</em> is delightful entertainment—with a pinch of chilli and Attic salt added.’</p>
</a><p class="indent"><a id="page_ii"></a><a id="page_iii">I wrote the novel paragraph by paragraph while travelling with my friend Harry Harrison round the USA, pausing only to dine with Ray Bradbury, one evening by the coast.</a></p><a id="page_iii">
<p class="indent">That may account for the way the text is interspersed with songs—elaborate songs at that; songs far too elaborate to reach the charts.</p>
<p class="indent">Well, I was younger then.</p>
<p class="indent">Or, as my current publisher might put it, I’m older now.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Introduction.vue?09244fb0